import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/frontend/node_modules/.pnpm/next-intl@4.13.2_next@14.2.35_react-dom@18.3.1_react@18.3.1__react@18.3.1__react@18.3.1_typescript@6.0.3/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/frontend/node_modules/.pnpm/next@14.2.35_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/frontend/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["DeferredThirdParty"] */ "/opt/buildhome/repo/frontend/src/components/DeferredThirdParty.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogPageView"] */ "/opt/buildhome/repo/frontend/src/components/PostHogPageView.tsx");
